import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addIntegrationApi,
  editMapCheckInFormApi,
  getIntegrationApi,
  uploadassetsApi,
  uploadLogoApi,
} from "../apis";
import { GetGBPAction } from "./AdminActions/GBPActions";
import { showSnackbar } from "../slices/SnackbarSlice";
import {
  cancelCheckinSubscriptionApi,
  restoreCheckinSubscriptionApi,
  enhanceDescriptionApi,
  generatePostDescriptionApi,
  facebookExchangeTokenApi,
  getGMBreviewsApi,
  instagramExchangeTokenApi,
  instagramPortfolioExchangeTokenApi,
  updateWidgetPreferenceIntegrationApi,
  youtubeExchangeTokenApi,
  tiktokExchangeTokenApi,
  listAudioApi,
  jobberExchangeTokenApi,
  companyCamExchangeTokenApi,
  companyCamConfigApi,
  jobberConfigApi,
  JobberConfigData,
  bulkScheduleCheckinsApi,
  getReviewsApi,
  refreshReviewsApi,
  getReviewSummaryApi,
  replyReviewApi,
  confirmDraftReviewApi,
  generateReviewRequestApi,
  toggleAutomationApi,
  getReviewConfigApi,
  updateReviewConfigApi,
  listAgentsApi,
  createAgentApi,
  editAgentApi,
  deleteAgentApi,
  generateQuickReplyApi,
  checkinBusinessCustomerPortalApi,
  checkinBusinessSetupPaymentMethodApi,
  checkinBusinessSubscriptionDetailsApi,
  checkinBusinessInvoicesApi,
  checkinBusinessTopupsApi,
  retryPurchaseApi,
  getAutoChargeConfigApi,
  updateAutoChargeConfigApi,
  listCreditAlertsApi,
  addCreditAlertApi,
  editCreditAlertApi,
  deleteCreditAlertApi,
} from "../apis/MapCheckInDashboardApi";
import { CompanyCamConfigData } from "../../components/PlatformIntegration/CompanyCam";

export const uploadLogoAction = createAsyncThunk(
  "upload/logo",
  async (payload: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await uploadLogoApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.message || "failed to upload logo",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);
export const uploadassetsAction = createAsyncThunk(
  "upload/assets",
  async (payload: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await uploadassetsApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.message || "failed to upload assests",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const editMapCheckInFormAction = createAsyncThunk(
  "edit-mapchekin-form",
  async (payload: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await editMapCheckInFormApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" }),
      );
      dispatch(GetGBPAction());
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.message || "failed to edit profile form",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getIntegrationAction = createAsyncThunk(
  "get/integration",
  async (business_id: string, { rejectWithValue, dispatch }) => {
    try {
      const response = await getIntegrationApi(business_id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const addIntegrationAction = createAsyncThunk(
  "add/integration",
  async (
    payload: { checkin_id: string; type: string },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await addIntegrationApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.message || "failed to add integration",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const facebookExchangeTokenAction = createAsyncThunk(
  "facebook/exchangeToken",
  async (
    payload: { bridge_token: string; code: string; workspaceId: string },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await facebookExchangeTokenApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.message || "failed to add integration",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const instagramExchangeTokenAction = createAsyncThunk(
  "instagram/exchangeToken",
  async (
    payload: { bridge_token: string; code: string; workspaceId: string },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await instagramExchangeTokenApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.message || "failed to add integration",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const youtubeExchangeTokenAction = createAsyncThunk(
  "youtube/exchangeToken",
  async (
    payload: { bridge_token: string; workspaceId: string },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await youtubeExchangeTokenApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.message || "failed to add integration",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const tiktokExchangeTokenAction = createAsyncThunk(
  "tiktok/exchangeToken",
  async (
    payload: { bridge_token: string; workspaceId: string },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await tiktokExchangeTokenApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.message || "failed to add integration",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const instagramPortfolioExchangeTokenAction = createAsyncThunk(
  "instagram-portfolio/exchange-token",
  async (
    payload: { bridge_token: string; code: string; workspaceId: string },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await instagramPortfolioExchangeTokenApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.message || "failed to add integration",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const enhanceDescriptionAction = createAsyncThunk(
  "action/enhanceDescription",
  async (
    payload: {
      business_id: string;
      description: string;
      categories?: string[];
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await enhanceDescriptionApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.message || "failed to enhance description",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const generatePostDescriptionAction = createAsyncThunk(
  "action/generatePostDescription",
  async (
    payload: {
      media: string;
      business_id: string;
      description?: string;
      category_ids?: string[];
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await generatePostDescriptionApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.message || "failed to generate description",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const cancelCheckinSubscriptionAction = createAsyncThunk(
  "cancel/checkin/subscription",
  async (payload: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await cancelCheckinSubscriptionApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.message,
          type: "error",
        }),
      );
      return rejectWithValue(
        error?.message || "Failed to cancel checkin subscription",
      );
    }
  },
);

export const restoreCheckinSubscriptionAction = createAsyncThunk(
  "restore/checkin/subscription",
  async (payload: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await restoreCheckinSubscriptionApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.message,
          type: "error",
        }),
      );
      return rejectWithValue(
        error?.message || "Failed to restore checkin subscription",
      );
    }
  },
);

export const getGMBreviewsAction = createAsyncThunk(
  "getgmb",
  async (payload: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await getGMBreviewsApi(payload);
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.message,
          type: "error",
        }),
      );
      return rejectWithValue(error?.message || "Failed to get reviews");
    }
  },
);

export const updateWidgetPreferenceIntegrationAction = createAsyncThunk(
  "update/widget-preference-integration",
  async (
    payload: {
      integration_id: string;
      widget_preference: string;
      selected_widgets: string[];
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await updateWidgetPreferenceIntegrationApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.message || "failed to update preference",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const listAudioAction = createAsyncThunk(
  "list/audio",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await listAudioApi();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const jobberExchangeTokenAction = createAsyncThunk(
  "jobber/exchangeToken",
  async (
    payload: { code?: string; businessId?: string },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await jobberExchangeTokenApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.message || "failed to add integration",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const companyCamExchangeTokenAction = createAsyncThunk(
  "company-cam/exchangeToken",
  async (
    payload: { code?: string; businessId?: string },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await companyCamExchangeTokenApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.message || "failed to add integration",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);
export const companyCamConfigAction = createAsyncThunk(
  "company-cam/config",
  async (payload: CompanyCamConfigData, { rejectWithValue, dispatch }) => {
    try {
      const response = await companyCamConfigApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.message || "failed to add integration",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const jobberConfigAction = createAsyncThunk(
  "jobber/config",
  async (payload: JobberConfigData, { rejectWithValue, dispatch }) => {
    try {
      const response = await jobberConfigApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.message || "failed to save jobber configs",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const bulkScheduleCheckinsAction = createAsyncThunk(
  "checkin/bulk-schedule-checkins",
  async (payload: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await bulkScheduleCheckinsApi(payload);
      dispatch(
        showSnackbar({
          message:
            response?.data?.message || "Bulk check-ins scheduled successfully!",
          type: "success",
        }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.message ||
            "Failed to schedule bulk check-ins",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getReviewsAction = createAsyncThunk(
  "reviews/get-reviews",
  async (payload: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await getReviewsApi(payload);
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.message || "Failed to fetch reviews",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const refreshReviewsAction = createAsyncThunk(
  "reviews/refresh-reviews",
  async (payload: { business_id: string }, { rejectWithValue, dispatch }) => {
    try {
      const response = await refreshReviewsApi(payload);
      dispatch(
        showSnackbar({
          message: response?.data?.message || "Reviews refreshed successfully",
          type: "success",
        }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.message || "Failed to refresh reviews",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const replyReviewAction = createAsyncThunk(
  "reviews/reply-review",
  async (
    payload: {
      business_id: string;
      review_name: string;
      reply_comment: string;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await replyReviewApi(payload);
      dispatch(
        showSnackbar({
          message: response?.data?.message || "Reply sent successfully",
          type: "success",
        }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.message || "Failed to send reply",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const confirmDraftReviewAction = createAsyncThunk(
  "reviews/confirm-draft",
  async (
    payload: {
      business_id: string;
      review_id: string;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await confirmDraftReviewApi(payload);
      dispatch(
        showSnackbar({
          message:
            response?.data?.message || "Reply approved and sent successfully",
          type: "success",
        }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.message || "Failed to confirm draft reply",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const generateReviewRequestAction = createAsyncThunk(
  "review/generateRequest",
  async (
    payload: { business_id: string; message: string; images?: string[] },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await generateReviewRequestApi(payload);
      dispatch(
        showSnackbar({
          message:
            response?.data?.message || "Review request sent successfully",
          type: "success",
        }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.message || "Failed to send review request",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getReviewSummaryAction = createAsyncThunk(
  "reviews/get-summary",
  async (payload: { business_id: string }, { rejectWithValue, dispatch }) => {
    try {
      const response = await getReviewSummaryApi(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const toggleAutomationAction = createAsyncThunk(
  "reviews/toggle-automation",
  async (
    payload: { business_id: string; enabled: boolean },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await toggleAutomationApi(payload);
      dispatch(
        showSnackbar({
          message:
            response?.data?.message ||
            `Auto-reply automation ${payload.enabled ? "enabled" : "disabled"} successfully`,
          type: "success",
        }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.message ||
            "Failed to toggle auto-reply automation",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getReviewConfigAction = createAsyncThunk(
  "reviews/get-config",
  async (payload: { business_id: string }, { rejectWithValue }) => {
    try {
      const response = await getReviewConfigApi(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const updateReviewConfigAction = createAsyncThunk(
  "reviews/update-config",
  async (
    payload: {
      business_id: string;
      star_rating_actions: Record<
        string,
        { action: string; agent_id?: string }
      >;
      guardrails: {
        min_age_days_disabled: number;
        banned_words: string[];
      };
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await updateReviewConfigApi(payload);
      dispatch(
        showSnackbar({
          message:
            response?.data?.message ||
            "Auto-reply automation updated successfully",
          type: "success",
        }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.message ||
            "Failed to update auto-reply automation settings",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const listAgentsAction = createAsyncThunk(
  "reviews/agents-list",
  async (
    payload: { business_id?: string } | undefined,
    { rejectWithValue },
  ) => {
    try {
      const response = await listAgentsApi(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const createAgentAction = createAsyncThunk(
  "reviews/agents-create",
  async (
    payload: {
      business_id?: string;
      name: string;
      instructions: string;
      tones: string[];
      language: string;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await createAgentApi(payload);
      dispatch(
        showSnackbar({
          message: response?.data?.message || "Agent created successfully",
          type: "success",
        }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.message || "Failed to create agent",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const editAgentAction = createAsyncThunk(
  "reviews/agents-edit",
  async (
    payload: {
      agent_id: string;
      business_id?: string;
      name: string;
      instructions: string;
      tones: string[];
      language: string;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await editAgentApi(payload);
      dispatch(
        showSnackbar({
          message: response?.data?.message || "Agent updated successfully",
          type: "success",
        }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.message || "Failed to update agent",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const deleteAgentAction = createAsyncThunk(
  "reviews/agents-delete",
  async (
    payload: { agent_id: string; business_id?: string },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await deleteAgentApi(payload);
      dispatch(
        showSnackbar({
          message: response?.data?.message || "Agent deleted successfully",
          type: "success",
        }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.message || "Failed to delete agent",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const generateQuickReplyAction = createAsyncThunk(
  "reviews/generate-quick-reply",
  async (
    payload: { business_id: string; review_comment: string },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await generateQuickReplyApi(payload);
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.message || "Failed to generate AI reply",
          type: "error",
        }),
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const checkinBusinessCustomerPortalAction = createAsyncThunk(
  "checkin/business/customer-portal",
  async (payload: { business_id: string }, { rejectWithValue, dispatch }) => {
    try {
      const response = await checkinBusinessCustomerPortalApi(payload);
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.message || "Failed to load customer portal",
          type: "error",
        }),
      );
      return rejectWithValue(
        error?.response?.data?.message ||
          "Could not get checkin customer portal",
      );
    }
  },
);

export const checkinBusinessSetupPaymentMethodAction = createAsyncThunk(
  "checkin/business/setup-payment-method",
  async (
    payload: {
      business_id: string;
      billingDetailsCollectionConfiguration?: {
        name?: "always" | "auto" | "never";
        email?: "always" | "auto" | "never";
      };
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await checkinBusinessSetupPaymentMethodApi(payload);
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.message || "Failed to setup payment method",
          type: "error",
        }),
      );
      return rejectWithValue(
        error?.response?.data?.message ||
          "Could not setup payment method",
      );
    }
  },
);

export const checkinBusinessSubscriptionDetailsAction = createAsyncThunk(
  "checkin/business/subscription-details",
  async (payload: { business_id: string }, { rejectWithValue }) => {
    try {
      const response = await checkinBusinessSubscriptionDetailsApi(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message ||
          "Could not fetch subscription details",
      );
    }
  },
);

export const checkinBusinessInvoicesAction = createAsyncThunk(
  "checkin/business/invoices",
  async (
    payload: {
      business_id: string;
      page: number;
      limit: number;
      sort_by?: string;
      sort_order?: string;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await checkinBusinessInvoicesApi(payload);
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.message || "Failed to load invoices",
          type: "error",
        }),
      );
      return rejectWithValue(
        error?.response?.data?.message || "Could not fetch invoices",
      );
    }
  },
);

export const checkinBusinessTopupsAction = createAsyncThunk(
  "checkin/business/topups",
  async (
    payload: {
      business_id: string;
      page: number;
      limit: number;
      sort_by?: string;
      sort_order?: string;
      charge_filter?: "auto" | "manual";
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await checkinBusinessTopupsApi(payload);
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.message || "Failed to load top-ups",
          type: "error",
        }),
      );
      return rejectWithValue(
        error?.response?.data?.message || "Could not fetch top-ups",
      );
    }
  },
);

export const retryPurchaseAction = createAsyncThunk(
  "addon/retry-purchase",
  async (payload: { transaction_id: string }, { rejectWithValue, dispatch }) => {
    try {
      const response = await retryPurchaseApi(payload);
      dispatch(
        showSnackbar({
          message: response?.data?.message || "Purchase retried successfully",
          type: "success",
        }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.message || "Failed to retry purchase",
          type: "error",
        }),
      );
      return rejectWithValue(
        error?.response?.data?.message || "Could not retry purchase",
      );
    }
  },
);

export const getAutoChargeConfigAction = createAsyncThunk(
  "checkin/business/getAutoChargeConfig",
  async (payload: { business_id: string }, { rejectWithValue, dispatch }) => {
    try {
      const response = await getAutoChargeConfigApi(payload);
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.message || "Failed to load auto-charge config",
          type: "error",
        }),
      );
      return rejectWithValue(
        error?.response?.data?.message || "Could not fetch auto-charge config",
      );
    }
  },
);

export const updateAutoChargeConfigAction = createAsyncThunk(
  "checkin/business/updateAutoChargeConfig",
  async (
    payload: {
      business_id: string;
      auto_charge_enabled: boolean;
      minimum_balance: number;
      target_balance: number;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await updateAutoChargeConfigApi(payload);
      dispatch(
        showSnackbar({
          message: response?.data?.message || "Auto-reload config updated successfully",
          type: "success",
        }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.message || "Failed to update auto-charge config",
          type: "error",
        }),
      );
      return rejectWithValue(
        error?.response?.data?.message || "Could not update auto-charge config",
      );
    }
  },
);

export const listCreditAlertsAction = createAsyncThunk(
  "checkin/business/listCreditAlerts",
  async (payload: { business_id: string }, { rejectWithValue, dispatch }) => {
    try {
      const response = await listCreditAlertsApi(payload);
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.message || "Failed to load credit alerts",
          type: "error",
        }),
      );
      return rejectWithValue(
        error?.response?.data?.message || "Could not fetch credit alerts",
      );
    }
  },
);

export const addCreditAlertAction = createAsyncThunk(
  "checkin/business/addCreditAlert",
  async (
    payload: { business_id: string; threshold: number },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await addCreditAlertApi(payload);
      dispatch(
        showSnackbar({
          message: response?.data?.message || "Alert added successfully",
          type: "success",
        }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.message || "Failed to add alert",
          type: "error",
        }),
      );
      return rejectWithValue(
        error?.response?.data?.message || "Could not add alert",
      );
    }
  },
);

export const editCreditAlertAction = createAsyncThunk(
  "checkin/business/editCreditAlert",
  async (
    payload: { alert_id: string; business_id: string; threshold: number },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await editCreditAlertApi(payload);
      dispatch(
        showSnackbar({
          message: response?.data?.message || "Alert updated successfully",
          type: "success",
        }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.message || "Failed to update alert",
          type: "error",
        }),
      );
      return rejectWithValue(
        error?.response?.data?.message || "Could not update alert",
      );
    }
  },
);

export const deleteCreditAlertAction = createAsyncThunk(
  "checkin/business/deleteCreditAlert",
  async (
    payload: { alert_id: string; business_id: string },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response = await deleteCreditAlertApi(payload);
      dispatch(
        showSnackbar({
          message: response?.data?.message || "Alert deleted successfully",
          type: "success",
        }),
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.message || "Failed to delete alert",
          type: "error",
        }),
      );
      return rejectWithValue(
        error?.response?.data?.message || "Could not delete alert",
      );
    }
  },
);
